import React from 'react';
import { object } from 'prop-types';
import ReviewFeedItem from '../feedItems/ReviewFeedItem';
import PhotosFeedItem from '../feedItems/PhotosFeedItem';
import ListFeedItem from '../feedItems/ListFeedItem';
import {
  REVIEWS_CREATED,
  TRAIL_COMPLETED,
  TRAIL_PHOTOS_UPLOADED,
  ACTIVITY_CREATED,
  ACTIVITY_PHOTOS_UPLOADED,
  LIST_CREATED,
  LIST_ITEM_ADDED
} from '../../constants';

const FeedSwitch = ({ itemData }) => {
  switch (itemData.itemType) {
    case REVIEWS_CREATED:
      return <ReviewFeedItem {...itemData} />;
    case TRAIL_COMPLETED:
      return <ReviewFeedItem {...itemData} />;
    case TRAIL_PHOTOS_UPLOADED:
      return <PhotosFeedItem {...itemData} />;
    case ACTIVITY_CREATED:
      return <h1>Activity Created</h1>;
    case ACTIVITY_PHOTOS_UPLOADED:
      return <h1>activity photos uploaded</h1>;
    case LIST_ITEM_ADDED:
      return <ListFeedItem {...itemData} />;
    default:
      return <h1>Still Todo: {itemData.itemType}</h1>;
  }
};

FeedSwitch.propTypes = {
  itemData: object.isRequired // this object varies depending on what comes back, more explicit proptypes in the children components
};

export default FeedSwitch;
